function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSezione05Popup04Ico06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 103.42 112.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M36.25,75.99v33.12c0,1.22-.99,2.21-2.21,2.21H11.97c-1.22,0-2.21-.99-2.21-2.21V42.88M23.01,71.58v39.74",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinejoin: "round",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.97,11.97c0,6.1,4.94,11.04,11.04,11.04s11.04-4.94,11.04-11.04S29.1.93,23.01.93s-11.04,4.94-11.04,11.04Z",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinejoin: "round",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.65,73.78c4.88,0,8.83-3.95,8.83-8.83v-28.19c0-3.34-2.15-6.3-5.32-7.37-1.43-.48-5.72-1.97-5.72-1.97l-11.04,11.04-11.04-11.04s-4.29,1.49-5.72,1.97c-3.16,1.07-5.32,4.03-5.32,7.37v3.91M93.66,42.88v66.23c0,1.22-.99,2.21-2.21,2.21h-22.08c-1.22,0-2.21-.99-2.21-2.21v-24.28M80.41,71.58v39.74",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinejoin: "round",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.37,11.97c0,6.1,4.94,11.04,11.04,11.04s11.04-4.94,11.04-11.04S86.5.93,80.41.93s-11.04,4.94-11.04,11.04Z",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinejoin: "round",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "62.75 51.35 71.58 60.18 62.75 69.02",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinejoin: "round",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36.25,
    y1: 60.18,
    x2: 71.58,
    y2: 60.18,
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinejoin: "round",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "40.67 58.33 31.84 49.5 40.67 40.67",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinejoin: "round",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 67.16,
    y1: 49.5,
    x2: 31.84,
    y2: 49.5,
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinejoin: "round",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.29,31.84c-.91-1.1-2.1-1.97-3.52-2.45-1.43-.48-5.72-1.97-5.72-1.97l-11.04,11.04-11.04-11.04s-4.29,1.49-5.72,1.97c-3.16,1.07-5.32,4.03-5.32,7.37v28.19c0,4.88,3.95,8.83,8.83,8.83",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinejoin: "round",
      strokeWidth: "1.86px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSezione05Popup04Ico06);
export default __webpack_public_path__ + "static/media/sezione-05-popup-04-ico-06.a46b381d9c2bedc923205242e06276a5.svg";
export { ForwardRef as ReactComponent };